<div>
	<div
		class="files-holder"
		(click)="downloadFile(fileEntry)"
		*ngFor="let fileEntry of currentFileEntries">
		<div class="file-icon-holder">
			<i [class]="'fileIcon fas '+ fileEntry.fileIconClass()">
			</i>
		</div>
		<div class="text-holder">
			{{fileEntry.original_file_name}}
		</div>
		<div class="delete-button" (click)="removeFileEntry(fileEntry)" *ngIf="edit">
			<qo-icon
				[icon]="EQORebrandIcon.trash_dark"
				[invertedScheme]="true"
				[scheme]="EQORebrandColor.SECONDARY"
				[color]="EQORebrandColor.SECONDARY"
				[size]="'sm'"
			></qo-icon>
		</div>
	</div>
</div>
